import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Nick
 * id ED0E86DB-C4A5-477B-82BF-FC5849EE0B9C
 * name bread-slice
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bread-slice.svg
 * tags
 * - Food / Drink 
 */
export const BreadSliceIcon = createSvgIcon(<><path d="M12,2C17.5,2 22,5.36 22,9.5C22,11.19 21.26,12.75 20,14V22H4V14C2.74,12.75 2,11.19 2,9.5C2,5.36 6.5,2 12,2M8,18H12V14H8V18Z" /></>, 'BreadSliceIcon');
export default BreadSliceIcon